module.exports = __webpack_public_path__ + "static/media/model.dcb4a1a1.glb";